import React from 'react';
import LongText from '../Elements/LongText';

/**
 * One Opportunity a Security Checklist may be copied FROM (CD-5407), as the source picker's data table shows it:
 * the Opportunity's id and name plus the date its checklist was completed. Modelled on ServiceFromItem - the
 * equivalent item behind "Copy Service From" - so the two pickers behave identically: one radio-selected row,
 * `clickOnSelect` bound by the hosting panel.
 */
export default class ChecklistCopySourceItem {
  constructor(item) {
    this.OpportunityId = item?.opportunityId ?? '';
    this.OpportunityName = item?.opportunityName ?? '';
    this.ClientName = item?.clientName ?? '';
    // Date only - the time of day says nothing here.
    this.ChecklistCompletedOn = item?.checklistCompletedOnUtc
      ? String(item.checklistCompletedOnUtc).substring(0, 10)
      : '';
    this.Selected = false;
  }

  static FieldsToShowInDataTable() {
    return [
      { label: 'Selected', orderById: '', data: ChecklistCopySourceItem.getSelectedCellContent, minWidth: 20 },
      { label: 'ID', orderById: 'OpportunityId', data: 'OpportunityId', minWidth: 30 },
      {
        label: 'Opportunity',
        orderById: 'OpportunityName',
        data: ChecklistCopySourceItem.getOpportunityCellContent,
        minWidth: 70,
      },
      {
        label: 'Checklist completed',
        orderById: 'ChecklistCompletedOn',
        data: 'ChecklistCompletedOn',
        minWidth: 40,
      },
    ];
  }

  static getOpportunityCellContent(item) {
    return (
      <LongText
        text={item.OpportunityName ? item.OpportunityName : ' '}
        maxLength={40}
      />
    );
  }

  static getSelectedCellContent(item) {
    if (item.Selected === undefined) item.Selected = false;
    return (
      <div className='text-center'>
        <input
          type='radio'
          checked={item.Selected}
          onClick={() => {
            ChecklistCopySourceItem.clickOnSelect(item);
          }}
          onChange={() => {}} //Don't remove. This is necessary to eliminate the React warning!
        />
      </div>
    );
  }

  // Replaced by the hosting panel (see ChooseChecklistSourcePanel), exactly as ServiceFromItem's is.
  static clickOnSelect() {}
}
